var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner-container"},[_c('div',_vm._l((_vm.config.hotWords),function(word,index){return _c('el-tag',{key:index,staticStyle:{"margin-right":"10px","margin-bottom":"10px"},attrs:{"type":"info"}},[_vm._v(_vm._s(word))])}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b8d925","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/instrument/HotSearchComponent.vue
// module id = null
// module chunks = 